import { render, staticRenderFns } from "./newHelpActive.vue?vue&type=template&id=7db9a9f8&scoped=true&"
import script from "./newHelpActive.vue?vue&type=script&lang=js&"
export * from "./newHelpActive.vue?vue&type=script&lang=js&"
import style0 from "./newHelpActive.vue?vue&type=style&index=0&id=7db9a9f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db9a9f8",
  null
  
)

export default component.exports